// extracted by mini-css-extract-plugin
export default {"addDocumentsContainer":"Dropzone_addDocumentsContainer__jlo60","addDocuments":"Dropzone_addDocuments__Pwjo4","uploadText":"Dropzone_uploadText__jbrs4"};